import Vue from 'vue'
import VueRouter from 'vue-router'

import store from './store'

import ZpAuth from './pages/Auth.vue'
import ZpLinks from './pages/Links.vue'
import ZpInterestSearch from './pages/InterestSearch.vue'
import ZpVideos from './pages/Videos.vue'
import ZpPixels from './pages/Pixels.vue'
import ZpDomains from './pages/Domains.vue'
import ZpPlan from './pages/Plan.vue'
import ZpMyAccount from './pages/MyAccount.vue'
import ZpPrivacy from './pages/Privacy.vue'
import ZpTeam from './pages/Team.vue'
import ZpBot from './pages/Bot.vue'
import ZpThankYou from './pages/ThankYou.vue'
import ZpPreview from './pages/Preview.vue'
import ZpAffiliate from './pages/Affiliate.vue'

Vue.use(VueRouter)

const routes = [{
  path: '/links',
  component: ZpLinks,
  meta: { auth: true }
}, {
  path: '/interesses',
  component: ZpInterestSearch,
  meta: { auth: true }
}, {
  path: '/dominios',
  component: ZpDomains,
  meta: { auth: true }
}, {
  path: '/pixels',
  component: ZpPixels,
  meta: { auth: true }
}, {
  path: '/aprender-e-praticar',
  component: ZpVideos,
  meta: { auth: true }
}, {
  path: '/plano',
  component: ZpPlan,
  meta: { auth: true }
}, {
  path: '/afiliado',
  component: ZpAffiliate,
  meta: { auth: true }
}, {
  path: '/minhaconta',
  component: ZpMyAccount,
  meta: { auth: true }
}, {
  path: '/privacidade',
  component: ZpPrivacy,
  meta: { auth: true }
}, {
  path: '/equipe',
  component: ZpTeam,
  meta: { auth: true }
}, {
  path: '/bot',
  component: ZpBot,
  meta: { auth: true }
}, {
  path: '/auth',
  component: ZpAuth
}, {
  path: '/preview',
  component: ZpPreview
}, {
  path: '/obrigado',
  component: ZpThankYou
}, {
  path: '*',
  redirect: '/auth'
}]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.auth)) {
    if (!store.state.auth.jwt) {
      next({
        path: '/auth',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
